import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "./Reveal";
import { DIFFERENTIALS } from "@/data";

export const WhyUs = () => (
    <section id="diferenciais" data-testid="why-us-section" className="bg-white py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <div className="grid lg:grid-cols-12 gap-12">
                <div className="lg:col-span-4">
                    <Reveal className="lg:sticky lg:top-28">
                        <SectionLabel>Diferenciais</SectionLabel>
                        <h2 className="mt-5 font-display font-bold text-navy tracking-tight text-4xl sm:text-5xl leading-[1.1]">
                            Por que escolher a{" "}
                            <span className="text-brand">Brandão Morais?</span>
                        </h2>
                        <p className="mt-6 text-navy/60 text-base leading-relaxed">
                            Cinco compromissos que guiam cada atendimento, do primeiro contato à
                            entrega do serviço.
                        </p>
                    </Reveal>
                </div>

                <div className="lg:col-span-8">
                    {DIFFERENTIALS.map((item, i) => (
                        <motion.div
                            key={item.title}
                            data-testid={`differential-item-${i}`}
                            initial={{ opacity: 0, y: 32 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.7, delay: 0.05 * i, ease: [0.22, 1, 0.36, 1] }}
                            className="group grid grid-cols-[auto_1fr] gap-6 sm:gap-10 items-start py-9 border-t-2 border-navy/10 first:border-t-0 first:pt-0 hover:border-brand transition-colors duration-500"
                        >
                            <span className="font-display font-extrabold text-5xl sm:text-7xl leading-none text-navy/10 group-hover:text-brand transition-colors duration-500 select-none">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div>
                                <h3 className="font-display font-bold text-navy text-2xl sm:text-3xl tracking-tight">
                                    {item.title}
                                </h3>
                                <p className="mt-3 text-navy/60 text-base leading-relaxed max-w-xl">
                                    {item.description}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    </section>
);
